// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';

// import agent from '../../../../assets/services/vdisolution/icons/enduser.png';
// import AP from '../../../../assets/services/vdisolution/icons/endtoend.png';
// import cloud from '../../../../assets/services/vdisolution/icons/bestdigital.png';
// import support from '../../../../assets/services/vdisolution/icons/support.png';

// const Cards = () => {
//   return (
//     <div className="disastercards disastercards-padding my-0 my-md-4">
//       <div className="disastercards-row">
//         <FeatureCard image={agent} title="Shared and Dedicated Desktops" description="With modern, streamlined approach we deliver Windows or Linux apps and desktops to users quickly and provide users with an interface that is familiar and easy-to-use.
// Individualized Apps. Publish apps on an individual user or group basis. Assigned apps dynamically appear within the users shared desktop without the need for a custom VDI desktop.
// Use Any Device. Access desktops and applications on any device, including tablets, ResoluteOS thin clients, or HTML5 Web browser.
// " />
//         <FeatureCard image={AP} title="Secure Remote Access to Apps and Data" description="We provide a set of features to secure remote access to apps and data no matter where you are, or which device you use. Users can self-manage security via the Virtual Desktop Security Portal, including password and 2FA settings via Inuvika authentication supporting mobile/email/USB secure keys and SAML2 providers (including Duo). It includes an Enterprise Secure Gateway that enables remote access without VPNs or custom security ports and uses modern TLS encryption for secure session communications. Admins can enforce granular user rights controls. It also provides smartcards and biometric device compatibility where supported by Windows applications." />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={cloud} title="Provide secure, zero-trust access to business-critical apps anywhere." description="Mixed Apps Support: Use Windows and Linux apps together, at the same time, within the same user interface and session. You won't have to install extra modules or launch separate sessions to use both. Apps run side-by-side and even share the same resources like clipboard.

// Multi-version Apps: Publish and assign multiple versions of the same app to users or groups that rely on them for specific workflows such as SAP and Microsoft Office.

// Extend the Life of Legacy Apps: That 'one' business app. We all have that one app we need to support. Virtual Desktop gives new life to legacy apps and enables users to access them on modern devices and operating systems.
// " />
//         <FeatureCard image={support} title="Support" description="Follow the Sun-Model - 24/7/365 days support from both On-shore and Off-shore Teams." />
//       </div>
//     </div>
//   );
// };

// export default Cards;


















import React from 'react';
import FeatureCard from '../../../../styles/FeatureCard.js';// Ensure path is correct
import '../../../../styles/disasterCard.css'; // Make sure the new CSS file is imported

// Import your images...
import agent from '../../../../assets/services/vdisolution/icons/enduser.png';
import AP from '../../../../assets/services/vdisolution/icons/endtoend.png';
// import cloud from '../../../../assets/services/vdisolution/icons/bestdigital.png';
import support from '../../../../assets/services/vdisolution/icons/support.png';
import FastDeployment from '../../../../assets/services/backup/icons/FastDeployment.svg';
import ConsistentAndFamiliar from '../../../../assets/services/backup/icons/ConsistentAndFamiliar.svg';
import ProvideSecure from '../../../../assets/services/backup/icons/ProvideSecure.svg';

const Cards = () => {
  const cardData = [
    {
      image: agent,
      title: "Shared and Dedicated Desktops",
      centered: true,
      description: (
        <>
          <p>
            It's with a modern, streamlined approach we deliver Windows or Linux apps and desktops to users quickly and provide users with an interface that is familiar and easy-to-use. Individualized Apps. Publish apps on an individual user or group basis. Assigned apps dynamically appear within the users shared desktop without the need for a custom VDI desktop. Use Any Device. Access desktops and applications on any device, including tablets, ResoluteOS thin clients, or HTML5 web browser.
          </p>

        </>
      )
    },
    {
      image: AP,
      title: "Secure Remote Access to Apps and Data",
      centered: true,
      description: (
        <p>
          We provide a set of features to secure remote access to apps and data no matter where you are, or which device you use. Users can self-manage security via the Virtual Desktop Security Portal, including password and 2FA settings via Inuvika authentication supporting mobile/email/USB secure keys and SAML2 providers (including Duo). It includes an Enterprise Secure Gateway that enables remote access without VPNs or custom security ports and uses modern TLS encryption for secure session communications. Admins can enforce granular user rights controls. It also provides smartcards and biometric device compatibility where supported by Windows applications.
        </p>
      )
    },
    {
      image: ProvideSecure,
      title: "Provide secure, zero-trust access to business-critical apps anywhere.",
      centered: true,
      description: (
        <>
          <p>
            Mixed Apps Support: Use Windows and Linux apps together, at the same time, within the same user interface and session. You won't have to install extra modules or launch separate sessions to use both. Apps run side-by-side and even share the same resources the clipboard. Multi-version Apps: Publish and assign multiple versions of the same app to users or groups that rely on them for specific workflows such as SAP and Microsoft Office. Extend the Life of Legacy Apps: Virtual Desktop gives new life to legacy apps and enables users to access them on modern devices and operating systems.
          </p>

        </>
      )
    },
    {
      image: FastDeployment,
      title: "Fast Deployment and Simplified Management.",
      centered: true,
      description: (
        <>
          <p>
            Unlike legacy solutions that can take weeks to configure, Synectiks offers OVD Enterprise solution deploys in hours with a single web-based admin console for centralized control of desktops and applications. A ready-to-use PoC will be provided promptly, helping clients test efficiently with secure access on all devices. The platform is optimized to work efficiently over LAN, WAN, and internet connections, including low-bandwidth or high-latency links. Adaptive display protocols adjust automatically based on network conditions, ensuring a smooth user experience even on mobile networks or remote locations.
          </p>

        </>
      )
    },
    {
      image: ConsistentAndFamiliar,
      title: "Consistent and Familiar User Experience.",
      centered: true,
      description: (
        <>
          <p>
            Synectiks DaaS delivers a smooth, familiar desktop experience that closely matches a local Windows or Linux system, reducing the learning curve for end users. Employees access their full desktop or individual applications through a simple login, with a consistent interface across browsers, desktops, laptops, thin clients and mobile devices helping users stay productive from day one. Features like session persistence, fast application launch, and seamless reconnection ensure users can continue their work without disruption, whether they are in the office, at home, or on the move.
          </p>

        </>
      )
    },
    {
      image: support,
      title: "Support",
      centered: true,
      description: (
        <p>
          Synectiks DaaS provides flexible support models, including break-fix resolution, co-managed IT augmentation, and a fully managed “Zero-Touch” service with end-to-end ownership of the desktop lifecycle - reducing operational risk, improving consistency, and enabling cost-predictable IT operations.
        </p>
      )
    }
  ];

  return (
    <div className="disastercards-section">
      <div className="disastercards-grid">
        {cardData.map((card, index) => (
          <FeatureCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            centered={card.centered}
          />
        ))}
      </div>
    </div>
  );
};

export default Cards;